import Notify from "config/notify";
import apiClient from "../../../config/apiClient";

const API_LIST_URL = `${process.env.REACT_APP_API_URL}/mst/4bundle/price/twset/select`;
const API_UPDATE_URL = `${process.env.REACT_APP_API_URL}/mst/4bundle/price/twset/update`;

/**
 * Handles errors by logging them or sending them to an error tracking service.
 * @param {string} message - The error message.
 * @param {any} error - The error object.
 */
const handleError = (message: string, error: any) => {
  // Replace this with your error handling logic
  console.error(message, error);
};

/**
 * @param {any} data - The data to fetch the client list.
 * @returns {Promise<any>} The data from the API response.
 * @throws Will throw an error if the request fails.
 */
const fetch4BundlePriceTwsetListApi = async (data: any): Promise<any> => {
  try {
    const response = await apiClient.post(`${API_LIST_URL}`, data);
    return response.data;
  } catch (error) {
    handleError("Error fetching clients:", error);
    throw error;
  }
};

/**
 * @param {any} data - The data to update the client.
 * @returns {Promise<any>} The data from the API response.
 * @throws Will throw an error if the request fails.
 */
const update4BundlePriceTwsetApi = async (data: any): Promise<any> => apiClient.post(`${API_UPDATE_URL}`, data);

export { fetch4BundlePriceTwsetListApi, update4BundlePriceTwsetApi };
